import { useEffect } from 'react';

const useEventListeners = (eventListeners) => {
  useEffect(() => {
    // Add event listeners
    eventListeners.forEach(({ eventName, eventHandler }) => {
      window.addEventListener(eventName, eventHandler);
    });

    // Cleanup: remove event listeners on unmount or when eventListeners change
    return () => {
      eventListeners.forEach(({ eventName, eventHandler }) => {
        window.removeEventListener(eventName, eventHandler);
      });
    };
  }, [eventListeners]);
};

export default useEventListeners;
